import React from "react"
import ZdqConnectorSetup from "../../components/ZdqConnectorSetup"
import { AZURE_BLOB_STORAGE } from "../../Constants"

function ZdqAzureBlobStorageConnector() {
    return <ZdqConnectorSetup vendor={AZURE_BLOB_STORAGE}></ZdqConnectorSetup>
}

export default ZdqAzureBlobStorageConnector 